/*
 
Skórki Material

 
*/

import * as M from '@material-ui/core';
import { palette } from '@mui/system';

//import './theme.css'

// https://in-your-saas.github.io/material-ui-theme-editor/
// http://mcg.mbitson.com/#!?mcgpalette0=%2338920a&mcgpalette2=%2326a69a&themename=rez1
// https://www.materialpalette.com/blue/lime

//https://material-ui.com/style/color/

// material

// po wpisaniu do pliku:
//import themeProject from './cfg/theme.json';

const theme = M.createTheme({
  //  palette: appPalette,
  palette: {
    primary: { light: "rgba(69, 139, 0, 0.5)", main: "#458B00", dark: '#69b076' },    //light: green[50]
    secondary: { light: "rgb(255, 165, 0)", main: "rgb(255, 165, 0)", dark: "rgb(178, 115, 0)" },
    error: { main: "rgb(244, 67, 54)", dark: "rgb(178, 115, 0)" },
    text: { secondary: "#555" }
  },
  //palette : themeProject.palette,
  typography: {
    /*?? */
    //   useNextVariants: true, 
  },
  overrides: {
    MuiButton: {
      root:{
        textTransform: "none" as "none"
      },
      containedSizeLarge: {
        fontSize: "1rem"
      }
    },
    MuiCheckbox: {
      root: {
        color: "#458B00"
      }
    },
    MuiTableCell: {
      root: {
        padding: "14px 5px 14px 16px",
        fontSize: "13px"
      }
    },
    MuiOutlinedInput: { 
      root: {
        //width: "80px"

        // "&:hover": {
        //   borderColor: "rgb(255, 165, 0)"
        // },
      },
      input: {
        //padding: "8px 14px",
        //textAlign: "center",
        //fontWeight: "bold",
        //width: "80px"
      },
      multiline: {
        padding: "0px"
      },
      notchedOutline: {
        //borderColor: "#458B00",
        //borderColor: "rgb(255, 165, 0)",
        borderColor: "lavender",
        borderRadius: "0px",
        borderWidth: "1px"
      }
    },
    MuiSelect: {
      root: {
       // padding: "6px 14px", textAlign: "left", fontSize: "13px", color: "red"
      },
      outlined: {
       // padding: "6px 14px", textAlign: "left", fontSize: "13px", color: "red"
      },
      selectMenu: {
        fontWeight: 400
      }
    },
    MuiLink: {
      underlineHover: {
        textDecoration: "underline"
      }
    }
   
    // MuiBackdrop: {
    //   root: {
    //     backgroundColor: "rgba(0, 0, 0, 0.06)",
    //   }
    // }
  },
}
)

/*
const styleAppBar = (theme : any) => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
})  
  
styleAppBar,
*/

/*const styles = createStyles(appPalette);

export { styles,  appPalette }
*/
export default theme
